import { DeleteModal, DeleteModalProps, Modal } from '@app/components/modals';
import { ModalInstance } from '@app/hooks/useModal';
import { IRole } from '@tickeat/permissions';

interface RoleDeleteModalProps
  extends ModalInstance<IRole>,
    Omit<DeleteModalProps<IRole>, 'children'> {
  onDelete: (role: Partial<IRole>) => void;
}

export const RoleDeleteModal = (props: RoleDeleteModalProps) => {
  return (
    <DeleteModal {...props}>
      <Modal.Subtitle>Vous allez supprimer un rôle.</Modal.Subtitle>
      <Modal.Message>Cette suppression est irréversible.</Modal.Message>
    </DeleteModal>
  );
};
